import { styled } from '@linaria/react';

export const PromoHeadButtonCustom = styled.button<{ mini?: boolean }>`
	display: flex;
	width: ${({ mini }) => (mini ? '38px' : 'auto')};
	height: 38px;
	align-items: center;
	justify-content: center;
	padding: ${({ mini }) => (mini ? '0' : '0 20px')};
	border-radius: ${({ mini }) => (mini ? '50%' : '40px')};
	backdrop-filter: blur(24px);
	box-shadow: 0px 0px 3px 0px #ff0095 inset, 0px 0px 8px 0px #7340df inset,
		0px 0px 8px 0px #ffcdff inset, 0px 0px 20px 0px #8349ff inset,
		0px 0px 5px 0px #000000 inset;
	gap: var(--gap-s);
`;
